module.exports = __webpack_public_path__ + "logoColomboWhite.svg?01f81a1aa1d33f03bea75dfb0c299649";